export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'Aperçu de la plateforme ouverte',
  'pages.openapi.overview.loadFailed': 'Échec du chargement de l\'aperçu d\'usage (l\'API n\'est peut-être pas prête)',
  'pages.openapi.overview.docsTitle': 'Guide d\'intégration',
  'pages.openapi.overview.docsDesc':
    'BasePath de la plateforme ouverte : /v1. Enveloppe de réponse : {code,message,data,request_id}. Pour les API Keys, envoyez Authorization: Bearer sk_live_... / sk_test_.... La clé en clair n\'est affichée qu\'une fois à la création ou à la rotation—conservez-la précieusement.',
  'pages.openapi.overview.level': 'Niveau actuel',
  'pages.openapi.overview.qps': 'Limite QPS',
  'pages.openapi.overview.apps': 'Apps',
  'pages.openapi.overview.appsSuffix': '(max {maxApps}, clés par app {maxKeys})',
  'pages.openapi.status.active': 'Actif',
  'pages.openapi.status.disabled': 'Désactivé',
  'pages.openapi.apps.title': 'Apps et clés',
  'pages.openapi.apps.listTitle': 'Mes apps',
  'pages.openapi.apps.create': 'Créer une app',
  'pages.openapi.apps.createModal': 'Créer une app',
  'pages.openapi.apps.name': 'Nom de l\'app',
  'pages.openapi.apps.nameRequired': 'Veuillez saisir un nom',
  'pages.openapi.apps.description': 'Description',
  'pages.openapi.apps.status': 'Statut',
  'pages.openapi.apps.createdAt': 'Créé le',
  'pages.openapi.apps.createSuccess': 'App créée',
  'pages.openapi.apps.createFailed': 'Échec de création de l\'app',
  'pages.openapi.apps.loadFailed': 'Échec du chargement des apps',
  'pages.openapi.apps.keysLoadFailed': 'Échec du chargement des clés',
  'pages.openapi.apps.delete': 'Supprimer',
  'pages.openapi.apps.deleteConfirm': 'Supprimer cette app ?',
  'pages.openapi.apps.deleted': 'Supprimée',
  'pages.openapi.apps.createKey': 'Créer une Key',
  'pages.openapi.apps.createKeyModal': 'Créer une API Key',
  'pages.openapi.apps.keyCreateSuccess': 'Clé créée',
  'pages.openapi.apps.keyCreateFailed': 'Échec de création de la clé',
  'pages.openapi.apps.noPlainKey': 'Aucune clé en clair renvoyée',
  'pages.openapi.apps.plainKeyTitle': 'Conservez votre API Key',
  'pages.openapi.apps.plainKeyHint': 'Le texte clair n\'est affiché qu\'une fois et ne pourra plus être consulté après fermeture.',
  'pages.openapi.apps.copy': 'Copier',
  'pages.openapi.apps.copied': 'Copié',
  'pages.openapi.apps.copyFailed': 'Échec de la copie ; sélectionnez manuellement',
  'pages.openapi.apps.close': 'Fermer',
  'pages.openapi.apps.key.name': 'Nom',
  'pages.openapi.apps.key.namePlaceholder': 'Clé principale de production',
  'pages.openapi.apps.key.prefix': 'Préfixe',
  'pages.openapi.apps.key.env': 'Environnement',
  'pages.openapi.apps.key.status': 'Statut',
  'pages.openapi.apps.key.createdAt': 'Créé le',
  'pages.openapi.apps.key.disable': 'Désactiver',
  'pages.openapi.apps.key.disableConfirm': 'Désactiver cette clé ?',
  'pages.openapi.apps.key.disabled': 'Désactivée',
  'pages.openapi.apps.key.enable': 'Activer',
  'pages.openapi.apps.key.enabled': 'Activée',
  'pages.openapi.apps.key.rotate': 'Faire pivoter',
  'pages.openapi.apps.key.rotateConfirm': 'La rotation génère une nouvelle clé et renvoie le clair une seule fois. Continuer ?',
  'pages.openapi.apps.key.rotated': 'Pivotée',
  'pages.openapi.apps.key.delete': 'Supprimer',
  'pages.openapi.apps.key.deleteConfirm': 'Supprimer cette clé ? Irréversible.',
  'pages.openapi.apps.key.deleted': 'Supprimée',
  'pages.openapi.logs.title': 'Journaux d\'utilisation',
  'pages.openapi.logs.listTitle': 'Détails des appels',
  'pages.openapi.logs.dailyTitle': 'Usage des 14 derniers jours',
  'pages.openapi.logs.dailyEmpty': 'Aucune donnée d\'usage quotidien',
  'pages.openapi.logs.date': 'Date',
  'pages.openapi.logs.count': 'Appels',
  'pages.openapi.logs.createdAt': 'Heure',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'Collez le request_id de la réponse API',
  'pages.openapi.logs.detail': 'Détails',
  'pages.openapi.logs.detailTitle': 'Détails de l\'appel',
  'pages.openapi.logs.detailLoading': 'Chargement…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'Requête',
  'pages.openapi.logs.responseBody': 'Réponse',
  'pages.openapi.logs.app': 'App',
  'pages.openapi.logs.appId': 'ID app',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ID utilisateur',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Préfixe Key',
  'pages.openapi.logs.method': 'Méthode',
  'pages.openapi.logs.path': 'Chemin',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': 'Code métier',
  'pages.openapi.logs.latency': 'Latence (ms)',
  'pages.openapi.logs.loadFailed': 'Échec du chargement',
  'pages.openapi.planTiers.title': 'Forfaits plateforme ouverte',
  'pages.openapi.planTiers.level': 'Niveau',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': 'Nom',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': 'Quota journalier',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'Apps max',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'Clés max par app',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': 'Enregistrer',
  'pages.openapi.planTiers.saved': 'Enregistré',
  'pages.openapi.planTiers.saveFailed': 'Échec de l\'enregistrement',
  'pages.openapi.planTiers.loadFailed': 'Échec du chargement des forfaits',
  'pages.openapi.planTiers.readonly': 'Les observateurs sont en lecture seule et ne peuvent pas modifier les forfaits',
  'pages.openapi.admin.usageLogsTitle': 'Audit des appels plateforme ouverte',
  'pages.openapi.admin.usageLogsList': 'Journaux d\'appels globaux',
  'pages.openapi.admin.disableKeyConfirm': 'Désactiver cette API Key ?',
  'pages.openapi.admin.disableKey': 'Désactiver la Key',
  'pages.openapi.admin.keyDisabled': 'Désactivée',
  'pages.openapi.admin.appsTitle': 'Apps plateforme ouverte',
  'pages.openapi.admin.appsList': 'Toutes les apps développeur',
  'pages.openapi.admin.developers': 'Développeurs',
  'pages.openapi.admin.apps': 'Apps',
  'pages.openapi.admin.keys': 'Clés totales',
  'pages.openapi.admin.activeKeys': 'Clés actives',
  'pages.openapi.admin.todayRequests': 'Appels du jour',
  'pages.openapi.admin.todayErrors': 'Erreurs du jour',
  'pages.openapi.admin.errorCount': 'Erreurs',
  'pages.openapi.admin.owner': 'Propriétaire',
  'pages.openapi.admin.keyCount': 'Clés',
  'pages.openapi.admin.keyword': 'Mot-clé',
  'pages.openapi.admin.keywordPlaceholder': 'Nom d\'app / description / code locataire',
  'pages.openapi.admin.statsLoadFailed': 'Échec du chargement des stats',
  'pages.openapi.admin.noKeys': 'Aucune clé',
  'pages.openapi.admin.appEnabled': 'App activée',
  'pages.openapi.admin.appDisabled': 'App désactivée',
  'pages.openapi.admin.appDisableConfirm': 'Désactiver cette app ?',
  'pages.openapi.admin.appEnableConfirm': 'Activer cette app ?',
  'pages.openapi.admin.keyEnableConfirm': 'Activer cette clé ?',
  'pages.admin.user.openapiDeveloperEnabled': 'Plateforme ouverte',
  'pages.admin.user.openapi.on': 'Activé',
  'pages.admin.user.openapi.off': 'Désactivé',
  'pages.admin.user.openapiLevel': 'Niveau plateforme ouverte',
  'pages.admin.user.openapiDeveloperEnabled.label': 'Activer le développeur',
  'pages.admin.user.openapiLevel.label': 'Niveau',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
  'pages.openapi.overview.dailyUsage': 'Usage du jour',
  'pages.openapi.apps.key.enableConfirm': 'Activer cette clé ?',
  'pages.admin.user.section.openapi': 'Plateforme ouverte',
};
